import { useQuery } from 'apollo-3';

import { checkFreeTrialEnrollmentEligibility } from 'GraphQL/query/Enrollment.query';

const useCheckFreeTrialEnrollmentEligible = ({ ...props }) => {
  const { data, loading, error, ...apolloUtils } = useQuery(checkFreeTrialEnrollmentEligibility, {
    ...props,
  });

  // ABLE_FOR_ENROLLMENT | ENROLLMENT_PENDING | ENROLLMENT_SUCCESS
  return {
    data: {
      isEligible:
        data?.erCheckFreeTrialEnrollmentEligibility?.success &&
        data?.erCheckFreeTrialEnrollmentEligibility?.status === 'ABLE_FOR_ENROLLMENT',
      status: data?.erCheckFreeTrialEnrollmentEligibility?.status,
    },
    loading,
    error,
    ...apolloUtils,
  };
};

export default useCheckFreeTrialEnrollmentEligible;
